import NavigationBarControl from '../../../lib/ui/NavigationBarControl'

export default class Welcome {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Welkom'
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let p = document.createElement('p')
    p.innerHTML = 'Hartelijk dank voor het gebruik van PRIM. Wij zullen in de volgende stappen u een aantal beveiligingsvragen stellen. Hierna kunt u beginnen met werken.'

    let button = document.createElement('button')
    button.innerHTML = 'Volgende'
    button.onclick = () => {
      window.PRIM.navigate('/entercredentials/')
    }

    div.appendChild(p)
    div.appendChild(button)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/start/action/Welcome.js